const T = 'cycle_counts.events.filters'
const ORDER = ['store_id', 'area', 'row', 'location_type']

export const eventFilterSummary = (filters, i18n) =>
  ORDER.filter(key => Array.isArray(filters?.[key]) && filters[key].length > 0)
    .map(key => `${i18n.t(`${T}.${key}`)} ${filters[key].join(', ')}`)
    .join(' · ')

// A store-wide manual event is the classic inventory; everything else is named by its scope.
// A non-store-wide event with no recognized filter keys would otherwise render as an empty
// string — fall back to the id so the panel title/list row is never blank.
export const eventLabel = (event, i18n) => {
  if (event?.store_wide) return i18n.t('cycle_counts.events.wall_to_wall')
  return eventFilterSummary(event?.filters, i18n) || i18n.t('cycle_counts.events.detail.open_event', { id: event?.id })
}
